import Footer from "../components/common/Footer.jsx";
import { Link } from "react-router-dom";
import Header from "../components/common/Header.jsx";
import css from "../components/common/innerPageStyles.js";

// TODO: replace with the real App Store URL
const APP_STORE_URL = "#";

const jsonLd = `{
 "@context": "https://schema.org",
 "@graph": [
  {
   "@type": "Organization",
   "@id": "https://www.futurefamilyai.com/#org",
   "name": "FutureFamilyAI",
   "url": "https://www.futurefamilyai.com/",
   "logo": "https://www.futurefamilyai.com/wp-content/uploads/futurefamilyai-logo.png",
   "parentOrganization": {
    "@type": "Organization",
    "name": "HelixFoundry, Inc."
   },
   "sameAs": [
    "[SOCIAL_PROFILE_URLS]"
   ]
  },
  {
   "@type": "WebPage",
   "@id": "https://www.futurefamilyai.com/surrogacy/independent-surrogate-agencies/#webpage",
   "url": "https://www.futurefamilyai.com/surrogacy/independent-surrogate-agencies/",
   "name": "Wellness App for Independent Surrogates | FutureFamilyAI",
   "description": "Independent surrogate? Get a consistent wellness routine, validated-cuff BP tracking and care-team review — with full control of your data.",
   "inLanguage": "en-US",
   "datePublished": "2026-10-20",
   "dateModified": "2026-10-20",
   "author": {
    "@type": "Person",
    "name": "Dr. Pooja Patel, MD",
    "jobTitle": "Surrogacy & Fertility Content Author, FutureFamilyAI",
    "url": "https://www.futurefamilyai.com/about/#pooja-patel",
    "worksFor": {
     "@type": "Organization",
     "name": "FutureFamilyAI"
    }
   },
   "reviewedBy": {
    "@type": "Person",
    "name": "Dr. Rashmi Gulati, MD",
    "jobTitle": "Medical Director, Patients Medical",
    "url": "https://www.futurefamilyai.com/about/#rashmi-gulati",
    "worksFor": {
     "@type": "Organization",
     "name": "Patients Medical"
    }
   },
   "lastReviewed": "2026-10-20",
   "publisher": {
    "@id": "https://www.futurefamilyai.com/#org"
   },
   "speakable": {
    "@type": "SpeakableSpecification",
    "cssSelector": [
     ".speakable-content"
    ]
   }
  },
  {
   "@type": "BreadcrumbList",
   "itemListElement": [
    {
     "@type": "ListItem",
     "position": 1,
     "name": "Home",
     "item": "https://www.futurefamilyai.com/"
    },
    {
     "@type": "ListItem",
     "position": 2,
     "name": "Surrogate Wellness",
     "item": "https://www.futurefamilyai.com/surrogacy/wellness-monitoring/"
    },
    {
     "@type": "ListItem",
     "position": 3,
     "name": "Independent Surrogates",
     "item": "https://www.futurefamilyai.com/surrogacy/independent-surrogate-agencies/"
    }
   ]
  },
  {
   "@type": "FAQPage",
   "mainEntity": [
    {
     "@type": "Question",
     "name": "Can I use FutureFamilyAI without a surrogacy agency?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Independent surrogates can enroll directly, subject to eligibility."
     }
    },
    {
     "@type": "Question",
     "name": "Is it free for independent surrogates?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "During the pilot, there's no subscription fee through December 31, 2026."
     }
    },
    {
     "@type": "Question",
     "name": "Can I share updates with intended parents?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, on your terms."
     }
    },
    {
     "@type": "Question",
     "name": "Does it give legal advice?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. Work with your own attorney."
     }
    },
    {
     "@type": "Question",
     "name": "What devices do I need?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "A validated cuff, a compatible phone and, for wellness trends, a smartwatch."
     }
    },
    {
     "@type": "Question",
     "name": "Can I switch to an agency later?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes. Your data stays yours."
     }
    },
    {
     "@type": "Question",
     "name": "Does FutureFamilyAI replace my doctor or prenatal visits?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "No. FutureFamilyAI is a wellness tool that organizes your readings and symptoms so your own clinician has more context between visits. Your care team makes every medical decision, and you should keep all scheduled appointments."
     }
    },
    {
     "@type": "Question",
     "name": "How much does FutureFamilyAI cost?",
     "acceptedAnswer": {
      "@type": "Answer",
      "text": "Eligible participants pay no subscription fee during the free pilot through December 31, 2026. After that, Complete Monitoring is $39.99/month or $399/year. A compatible phone, validated cuff and (for wearable trends) a smartwatch are purchased separately."
     }
    }
   ]
  }
 ]
}`;

export default function SurrogacyIndependentSurrogateAgenciesPage() {
  return (
    <div className="wrapper2">
      <style>{css}</style>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLd }}
      />
      <Header />
      <main className="ffh-home">
        <section className="ffh-page-hero">
          <div className="ffh-wrap">
            <nav className="ffh-crumbs" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span>›</span>
              <Link to="/surrogacy/wellness-monitoring">
                Surrogate Wellness
              </Link>
              <span>›</span>
              <span>Independent Surrogates</span>
            </nav>
            <aside className="ffh-facts" aria-label="Fast facts">
              <div className="ffh-facts-title">
                <svg
                  viewBox="0 0 24 24"
                  width="16"
                  height="16"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 11v6M12 7.5v.5" />
                </svg>{" "}
                Fast facts
              </div>
              <p className="ffh-q">
                Independent gestational surrogates can use FutureFamilyAI to
                keep a consistent wellness record — validated-cuff blood
                pressure, smartwatch trends and symptoms — with care-team review
                when a pattern needs attention and sharing fully under their
                control.
              </p>
              <details>
                <summary>
                  More fast facts: audience, key stat, safety, cost
                </summary>
                <dl>
                  <div>
                    <dt>Who it&apos;s for</dt>
                    <dd>Independent gestational surrogates</dd>
                  </div>
                  <div>
                    <dt>Key stat</dt>
                    <dd>
                      The USPSTF recommends screening for hypertensive disorders
                      of pregnancy with blood pressure measurements throughout
                      pregnancy. (USPSTF, 2023)
                    </dd>
                  </div>
                  <div>
                    <dt>Safety &amp; oversight</dt>
                    <dd>
                      Wellness tool, not a medical device. Orange and Red
                      statuses reviewed by a real care team. Not for emergencies
                      — call 911.
                    </dd>
                  </div>
                  <div>
                    <dt>Why FutureFamilyAI</dt>
                    <dd>
                      No agency required · Free during the pilot · You control
                      every share
                    </dd>
                  </div>
                  <div>
                    <dt>Cost</dt>
                    <dd>
                      Free pilot through Dec 31, 2026; then $39.99/mo or
                      $399/yr. Devices separate.
                    </dd>
                  </div>
                  <div>
                    <dt>Get started</dt>
                    <dd>
                      Download on the App Store, or request free pilot access at
                      futurefamilyai.com/contact/
                    </dd>
                  </div>
                </dl>
              </details>
            </aside>
            <p className="ffh-entity">
              FutureFamilyAI is a physician-connected pregnancy and
              family-planning wellness app that turns home blood pressure
              readings from a validated cuff, smartwatch wellness trends and
              symptom notes into a simple color status your care team can review
              between visits. Its monitoring protocol was developed by Dr.
              Kulsoom Baloch, MBBS, MPH, using ACOG, SMFM, ISSHP and AHA
              guidance, and every page is medically reviewed by Dr. Rashmi
              Gulati, MD, Medical Director of Patients Medical (Manhattan, since
              1974). FutureFamilyAI is a product of HelixFoundry, Inc., and is
              used by Surrogacy4All to support its gestational surrogates.
            </p>
            <span className="ffh-eyebrow">SURROGACY GUIDE</span>
            <h1>
              Wellness App for Independent Surrogates — Support On Your Terms
            </h1>
            <p className="ffh-answer speakable-content">
              Independent gestational surrogates can use FutureFamilyAI to keep
              a consistent wellness record — validated-cuff blood pressure,
              smartwatch trends and symptoms — with care-team review when a
              pattern needs attention and sharing fully under their control. It
              is free during the pilot through December 31, 2026. The app does
              not replace independent legal, obstetric or mental-health support.
              Enroll as an independent surrogate.
            </p>
            <div className="ffh-byline">
              <span>
                Written by{" "}
                <b>
                  <Link to="/about#pooja-patel">Dr. Pooja Patel, MD</Link>
                </b>
              </span>
              <span>
                Medically reviewed by{" "}
                <b>
                  <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                </b>
              </span>
              <span>Published October 2026 · Last updated October 2026</span>
            </div>
            <div className="ffh-cta-row">
              <Link
                className="ffh-btn ffh-primary"
                to="/contact-us?type=member"
              >
                Request Free Pilot Access
              </Link>
              <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                <svg
                  viewBox="0 0 24 24"
                  width="18"
                  height="18"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  aria-hidden="true"
                >
                  <path
                    d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                    fill="currentColor"
                    stroke="none"
                  />
                </svg>
                Download on the App Store
              </a>
            </div>
          </div>
        </section>
        <section className="ffh-band" style={{ paddingBlock: "40px 64px" }}>
          <div className="ffh-wrap ffh-layout">
            <div className="ffh-prose">
              <figure
                className="ffh-photo"
                role="img"
                aria-label="Independent gestational surrogate managing her wellness routine"
              >
                <figcaption>
                  <b>Photo slot</b> · Confident woman in her 30s, visibly
                  pregnant, at her home office desk with phone and coffee;
                  independent, organized. No text.
                  <br />
                  <b>Alt:</b> Independent gestational surrogate managing her
                  wellness routine
                </figcaption>
              </figure>
              <section className="ffh-keystats" id="key-stats">
                <h2>Key statistics</h2>
                <ul>
                  <li>
                    The USPSTF recommends screening for hypertensive disorders
                    of pregnancy with blood pressure measurements throughout
                    pregnancy.
                    <cite>
                      Source:{" "}
                      <a href="https://www.uspreventiveservicestaskforce.org/uspstf/recommendation/hypertensive-disorders-pregnancy-screening">
                        USPSTF, 2023
                      </a>
                    </cite>
                  </li>
                </ul>
              </section>
              <section id="s1">
                <h2>Why it helps without an agency</h2>
                <p>
                  Without an agency&apos;s support team, it&apos;s easy to carry
                  the coordination load alone. A simple daily routine and
                  shareable summaries reduce that burden.
                </p>
              </section>
              <section id="s2">
                <h2>Still essential</h2>
                <ul>
                  <li>Independent legal counsel</li>
                  <li>Your own obstetric care</li>
                  <li>Mental-health support if needed</li>
                </ul>
              </section>
              <div className="ffh-inline-cta">
                <p>Free pilot enrollment is open through December 31, 2026.</p>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
              <section id="faq">
                <h2>Frequently asked questions</h2>
                <div className="ffh-faq">
                  <details open>
                    <summary>
                      Can I use FutureFamilyAI without a surrogacy agency?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        Yes. Independent surrogates can enroll directly, subject
                        to eligibility.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Is it free for independent surrogates?</summary>
                    <div className="ffh-ans speakable-content">
                      <p>
                        During the pilot, there&apos;s no subscription fee
                        through December 31, 2026.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Can I share updates with intended parents?
                    </summary>
                    <div className="ffh-ans speakable-content">
                      <p>Yes, on your terms.</p>
                    </div>
                  </details>
                  <details>
                    <summary>Does it give legal advice?</summary>
                    <div className="ffh-ans">
                      <p>No. Work with your own attorney.</p>
                    </div>
                  </details>
                  <details>
                    <summary>What devices do I need?</summary>
                    <div className="ffh-ans">
                      <p>
                        A validated cuff, a compatible phone and, for wellness
                        trends, a smartwatch.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>Can I switch to an agency later?</summary>
                    <div className="ffh-ans">
                      <p>Yes. Your data stays yours.</p>
                    </div>
                  </details>
                  <details>
                    <summary>
                      Does FutureFamilyAI replace my doctor or prenatal visits?
                    </summary>
                    <div className="ffh-ans">
                      <p>
                        No. FutureFamilyAI is a wellness tool that organizes
                        your readings and symptoms so your own clinician has
                        more context between visits. Your care team makes every
                        medical decision, and you should keep all scheduled
                        appointments.
                      </p>
                    </div>
                  </details>
                  <details>
                    <summary>How much does FutureFamilyAI cost?</summary>
                    <div className="ffh-ans">
                      <p>
                        Eligible participants pay no subscription fee during the
                        free pilot through December 31, 2026. After that,
                        Complete Monitoring is $39.99/month or $399/year. A
                        compatible phone, validated cuff and (for wearable
                        trends) a smartwatch are purchased separately.
                      </p>
                    </div>
                  </details>
                </div>
                <div className="ffh-cta-row">
                  <Link
                    className="ffh-btn ffh-primary"
                    to="/contact-us?type=member"
                  >
                    Request Free Pilot Access
                  </Link>
                  <a className="ffh-btn ffh-ghost" href={APP_STORE_URL}>
                    <svg
                      viewBox="0 0 24 24"
                      width="18"
                      height="18"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      aria-hidden="true"
                    >
                      <path
                        d="M16 3c-1 .1-2.2.8-2.8 1.6-.6.7-1 1.8-.9 2.8 1.1.1 2.2-.6 2.8-1.4.6-.8 1-1.9.9-3zM19.5 16.6c-.5 1.1-.8 1.6-1.4 2.6-.9 1.4-2.2 3-3.7 3-1.4 0-1.7-.9-3.6-.9s-2.3.9-3.6.9c-1.6 0-2.8-1.5-3.7-2.9C1.1 15.4.8 10.8 2.4 8.4c1.1-1.7 2.9-2.7 4.6-2.7 1.7 0 2.8.9 4.2.9 1.4 0 2.2-.9 4.2-.9 1.5 0 3.1.8 4.2 2.2-3.7 2-3.1 7.3-.1 8.7z"
                        fill="currentColor"
                        stroke="none"
                      />
                    </svg>
                    Download on the App Store
                  </a>
                </div>
              </section>
              <section className="ffh-authorbox">
                <span className="ffh-ph">PP</span>
                <div className="ffh-stack" style={{ gap: "6px" }}>
                  <h3>Dr. Pooja Patel, MD</h3>
                  <p>
                    Surrogacy &amp; Fertility Content Author, FutureFamilyAI.
                    Dr. Pooja Patel, MD, writes FutureFamilyAI&apos;s surrogacy
                    and fertility content. Her work across the Surrogacy4All
                    network focuses on gestational carriers, IVF preparation and
                    family-building pathways.
                  </p>
                  <p>
                    Medically reviewed by{" "}
                    <Link to="/about#rashmi-gulati">Dr. Rashmi Gulati, MD</Link>
                    , Medical Director, Patients Medical. Last updated: October
                    2026.
                  </p>
                </div>
              </section>
              <section>
                <h2>Keep reading</h2>
                <div className="ffh-related">
                  <Link to="/surrogacy/wellness-monitoring">
                    Surrogate Wellness →
                  </Link>
                  <Link to="/surrogacy/surrogate-health-monitoring-app">
                    Surrogate Health Monitoring App →
                  </Link>
                  <Link to="/surrogacy/surrogate-blood-pressure-tracking">
                    Surrogate Blood Pressure Tracking →
                  </Link>
                  <Link to="/surrogacy/intended-parent-updates">
                    Intended Parent Updates →
                  </Link>
                  <Link to="/surrogacy/coordinator-role-wellness-app">
                    Coordinator Role →
                  </Link>
                  <Link to="/how-it-works">How it works →</Link>
                  <Link to="/pricing">Pricing &amp; free pilot →</Link>
                  <Link to="/privacy-safety">Privacy &amp; safety →</Link>
                  <Link to="/faq">FAQ →</Link>
                  <a href="https://www.surrogacy4all.com">
                    https://www.surrogacy4all.com →
                  </a>
                </div>
              </section>
              <p className="ffh-notice">
                FutureFamilyAI is a wellness and awareness tool. It is not a
                medical device, is not FDA-cleared, does not diagnose or treat
                any condition, and is not monitored in real time. It supports —
                and does not replace — your prenatal care. In an emergency, call
                911.
              </p>
            </div>
            <aside className="ffh-aside">
              <div className="ffh-toc">
                <b>What you will learn</b>
                <ol>
                  <li>
                    <a href="#s1">Why it helps without an agency</a>
                  </li>
                  <li>
                    <a href="#s2">Still essential</a>
                  </li>
                  <li>
                    <a href="#faq">Frequently asked questions</a>
                  </li>
                </ol>
              </div>
              <div className="ffh-cta-card">
                <b>Join the free pilot</b>
                <span>No subscription fee through Dec 31, 2026.</span>
                <Link
                  className="ffh-btn ffh-primary ffh-sm"
                  to="/contact-us?type=member"
                >
                  Request Free Pilot Access
                </Link>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
